import { createContext } from 'react';
export const Context = /*#__PURE__*/createContext(undefined);